export enum FolderBusinessEntityListVariant {
  Cards = 'cards',
  Grid = 'grid',
}
